import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
} from "react";
import axios from "axios";
import { Line } from "react-chartjs-2";
import { Card, Typography, TextField, Box } from "@mui/material";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Filler,
} from "chart.js";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Filler
);

const DestinationMRT = () => {
  const token = localStorage.getItem("token");

  const [date, setDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [labels, setLabels] = useState([]);
  const [values, setValues] = useState([]);
  const [loading, setLoading] = useState(false);

  const chartRef = useRef(null);
  const containerRef = useRef(null);

  // === FETCH DATA ===
  useEffect(() => {
    if (!token) return;

    setLoading(true);
    axios
      .get("https://portaldata.jaktraffic.my.id/pqs/mrtj/view", {
        params: { token, dt: date, lim: 50000, pg: 1 },
      })
      .then((res) => {
        const rows = res.data?.Data ?? [];
        const counter = {};

        rows.forEach((item) => {
          if (item?.destination) {
            counter[item.destination] =
              (counter[item.destination] || 0) + 1;
          }
        });

        setLabels(Object.keys(counter));
        setValues(Object.values(counter));
      })
      .finally(() => setLoading(false));
  }, [date, token]);

  // === DATASET ===
  const data = useMemo(
    () => ({
      labels,
      datasets: [
        {
          data: values,
          fill: true,
          borderColor: "#6366f1",
          borderWidth: 2,
          tension: 0.45,
          pointRadius: 2,
          backgroundColor: (ctx) => {
            const g = ctx.chart.ctx.createLinearGradient(0, 0, 0, 400);
            g.addColorStop(0, "rgba(99,102,241,0.35)");
            g.addColorStop(1, "rgba(99,102,241,0)");
            return g;
          },
        },
      ],
    }),
    [labels, values]
  );

  // === FIX RESIZE (AMAN) ===
  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new ResizeObserver(() => {
      if (chartRef.current?.chart) {
        chartRef.current.chart.resize();
      }
    });

    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <Card
      sx={{
        p: 3,
        borderRadius: 4,
        width: "100%",
        height: 420,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Jumlah Penumpang
        </Typography>

        <TextField
          type="date"
          size="small"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
      </Box>

      {/* CHART */}
      <Box
        ref={containerRef}
        sx={{
          flex: 1,
          position: "relative",
          width: "100%",
          minWidth: 0,
        }}
      >
        {loading ? (
          <Typography align="center">Loading...</Typography>
        ) : (
          <Line
            ref={chartRef}
            data={data}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              layout: { padding: 10 },
              plugins: {
                legend: { display: false },
                tooltip: {
                  mode: "index",
                  intersect: false,
                },
              },
              scales: {
                x: { grid: { display: false } },
                y: {
                  beginAtZero: true,
                  grid: { color: "rgba(0,0,0,0.05)" },
                  ticks: { stepSize: 500 },
                },
              },
            }}
          />
        )}
      </Box>
    </Card>
  );
};

export default DestinationMRT;
